import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { Navbar } from "@/components/site/Navbar";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Members from "@/pages/Members";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/accedi" element={<Login />} />
        <Route path="/area-membri" element={<Members />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <SmoothScroll />
            <AppRouter />
          </BrowserRouter>
          <Toaster theme="dark" position="top-center" />
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
